<template>
    <main-banner
        :title="$t('games.camelrace_banner_title')"
        players="2 - 4"
        :difficulty="$t('game_difficulty.medium')"
        :image="imageSrc"
        id="camelrace"
        @start-game="selectMatch('Camel Race')"
        :coming-soon="false"
    />

    <Modal
        :is-visible="showUnsupportedModal"
        :on-confirm="closeUnsupportedModal"
        :confirm-text="$t('maintenance.go_back')"
        hide-cancel
    >
        <h2
            class="justify-start text-center font-['Termina'] text-base leading-normal font-extrabold text-white"
        >
            {{ $t('games.camelrace_unavailable_title') }}
        </h2>
        <p
            class="mt-4 justify-start self-stretch text-center font-sans text-sm leading-normal font-normal text-white"
        >
            {{ $t('games.camelrace_unavailable_body') }}
        </p>
    </Modal>
</template>

<script>
import MainBanner from './Main.vue'
import Modal from '@/components/Modal.vue'
import img from '@images/games/camelrace/_banner.png?src'
import { mapStores } from 'pinia'
import { useMatchStore } from '@/stores/match.js'
import { useAuthStore } from '@/stores/auth.js'
import { isCamelRaceUnsupportedIOS } from '@/utils/platform.js'

export default {
    components: {
        MainBanner,
        Modal,
    },
    data() {
        return {
            showUnsupportedModal: false,
        }
    },
    props: {
        online: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapStores(useMatchStore, useAuthStore),
        imageSrc() {
            return img
        },
    },
    methods: {
        async selectMatch(type) {
            if (isCamelRaceUnsupportedIOS()) {
                this.showUnsupportedModal = true
                return
            }
            await this.matchStore.selectMatchType(
                type,
                this.authStore,
                this.$router,
                this.$toast,
                this.online,
            )
        },
        closeUnsupportedModal() {
            this.showUnsupportedModal = false
        },
    },
}
</script>
